<template>
  <div class="list mb-10">
    <v-row>
      <v-col class="d-flex justify-start">
      </v-col>
    </v-row>
    <h4>{{ $t("manage.by_edcity.header") }}</h4>
    <v-tabs
      v-model="tab"
      class="elevation-2"
      flat
      show-arrows
    > 
      <v-tab :href="`#tab-add-schools`">
        {{  $t("manage.by_edcity.tab.add_school") }}
      </v-tab>
      <v-tab :href="`#tab-list-product-schools`">
        {{  $t("manage.by_edcity.tab.list_product_schools") }}
      </v-tab>
      <v-tab :href="`#tab-list-school-students`">
        {{  $t("manage.by_edcity.tab.list_school_students") }}
      </v-tab>
      <v-tab :href="`#tab-add-update-school-students`">
        {{  $t("manage.by_edcity.tab.add_update_school_students") }}
      </v-tab>
      <v-tab :href="`#tab-list-school-teachers`">
        {{  $t("manage.by_edcity.tab.list_school_teachers") }}
      </v-tab>
      <v-tab :href="`#tab-add-update-school-teachers`">
        {{  $t("manage.by_edcity.tab.add_update_school_teachers") }}
      </v-tab>


      <v-tab-item :value="'tab-add-schools'">
        <AddSchool />
      </v-tab-item>
      <v-tab-item :value="'tab-list-product-schools'">
        <ListProductSchools />
      </v-tab-item>
      <v-tab-item :value="'tab-list-school-students'">
        <ListSchoolStudents />
      </v-tab-item>
      <v-tab-item :value="'tab-add-update-school-students'">
        <AddUpdateSchoolStudents />
      </v-tab-item>
      <v-tab-item :value="'tab-list-school-teachers'">
        <ListSchoolTeachers />
      </v-tab-item>
      <v-tab-item :value="'tab-add-update-school-teachers'">
        <AddUpdateSchoolTeachers />
      </v-tab-item>


    </v-tabs>
  </div>
</template>
<script>
import AddSchool from "@/components/management/edcity/AddSchool.vue";
import ListProductSchools from "@/components/management/edcity/ListProductSchools.vue";
import ListSchoolStudents from "@/components/management/edcity/ListSchoolStudents.vue";
import AddUpdateSchoolStudents from "@/components/management/edcity/AddUpdateSchoolStudents.vue";
import ListSchoolTeachers from "@/components/management/edcity/ListSchoolTeachers.vue";
import AddUpdateSchoolTeachers from "@/components/management/edcity/AddUpdateSchoolTeachers.vue";

export default {
  name: "admin",
  components: {
    AddSchool,
    ListProductSchools,
    ListSchoolStudents,
    AddUpdateSchoolStudents,
    ListSchoolTeachers,
    AddUpdateSchoolTeachers,
  },
  data: () => ({
    tab: null,
  }),
  mounted() {
    var self = this;
    if(self.$store.state.user.user_level!="ADMIN"){
        self.$store.commit('showSnackBar', "Access Denied");
        self.$router.push("/");
    }
  },
};
</script>